import React from "react";
import { Helmet } from "react-helmet";
import Foto1 from "../img/foto 1_daniel saboya.jpg";
import Foto2 from "../img/foto 2 dirigentes liberados tras participar en protesta.jpg";
import Foto3 from "../img/foto 3 Yvan Vasquez.jpg";
import Foto4 from "../img/foto 4 José Fachín.jpg";
import Foto5 from "../img/Foto 5 riter ochoa sosa.jpg";

import Fondo from "../img/IlustraciónportadaLoreto.jpg";
import SocialShare from "../components/SocialShare";
import { Fade } from "react-awesome-reveal";
import Author from "../img/luzmarina.jpg";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const NotaLoreto = () => {
  return (
    <>
      <Navbar />
      <div className="nota">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Loreto: Migajas para los hijos del “oro negro”</title>
          <meta
            property="og:title"
            content="Loreto: Migajas para los hijos del “oro negro”"
          />
          <meta
            name="description"
            content="Desde el año 2010, las comunidades nativas cercanas a los yacimientos de petróleo de Loreto deben acceder al 10% del canon."
          ></meta>
          <meta
            property="og:url"
            content={
              process.env.REACT_APP_URL + "/loreto-migajas-para-hijos-oro-negro"
            }
          />
          <meta property="og:image" content={"https://fundacionmohme.org"+Fondo} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:image:src" content={"https://fundacionmohme.org"+Fondo} />
        </Helmet>
        <div>
          <header className="">
            <div className="header-bg">
              <img
                className="img-fluid"
                src={Fondo}
                alt="Loreto: Migajas para los hijos del “oro negro”"
              />
            </div>
            <div className="nota-header-content  ">
              <div className="container d-flex justify-content-center flex-column">
                <Fade delay={80} triggerOnce>
                  <h1>Loreto: Migajas para los hijos del “oro negro”</h1>
                  <SocialShare
                    url={
                      process.env.REACT_APP_URL +
                      "/loreto-migajas-para-hijos-oro-negro"
                    }
                    text="Loreto: Migajas para los hijos del “oro negro”"
                  />
                  <p className="bajada d-none d-lg-block d-md-none">
                    Desde el año 2010, las comunidades nativas cercanas a los
                    yacimientos de petróleo de Loreto deben acceder al 10% del
                    canon. Tres gestiones regionales han pasado y a la fecha
                    solo hay evidencia de mala ejecución e investigaciones por
                    presunta corrupción.
                    <br></br>
                    <br></br>
                  </p>
                </Fade>
              </div>
            </div>
          </header>
        </div>
        <main>
          <div className="container">
            <Fade delay={80}>
              <p className="bajada d-none d-block d-lg-none">
                Desde el año 2010, las comunidades nativas cercanas a los
                yacimientos de petróleo de Loreto deben acceder al 10% del
                canon. Tres gestiones regionales han pasado y a la fecha solo
                hay evidencia de mala ejecución e investigaciones por presunta
                corrupción.
              </p>
            </Fade>
          </div>
          <div className="container">
            <Fade delay={80}>
              <div className="author d-flex">
                <div className="circle">
                  <img src={Author} className="img-fluid" alt="Luz Marina" />
                </div>
                Por Luz Marina Herrera – La Región
              </div>
            </Fade>

            <Fade delay={80}>
              <p>
                <span className="capital-letter">T</span>repados sobre un árbol
                de toronja, un grupo de niños indígenas observa en silencio.
                Tamaño suspenso genera la impresión de que van a cazar un animal
                salvaje. No es así. Al fondo, un grupo de foráneos tira a la
                basura y quema alimentos que los trabajadores de la empresa
                Pluspetrol no han consumido.
              </p>

              <p>
                Al día siguiente, más temprano, unos ocho niños decidieron
                treparse a una canoa y cruzaron el río Corrientes, que separa al
                pueblo con el campamento de Pluspetrol, empresa responsable de
                la explotación del Lote 8.
              </p>
              <p>
                El grupo de niños iba decidido a pedir a los cocineros de la
                empresa que no queme la sobra de la comida: podían llevárselo a
                sus casas. Los foráneos atendieron el pedido. Con los días, el
                acto se hizo rutina, pero la felicidad no duró mucho: pronto los
                jefes de la empresa se enteraron y ordenaron que nadie regale
                nada, bajo pena de despido. El mandato iba también para los
                niños: si los encontraban dentro del campamento, serían
                detenidos.
              </p>
              <p>
                Entre aquellos niños descalzos y de polos desteñidos, estaba
                Daniel Saboya Mayanchi. Flaco. Cabello y ojos más negros que el
                petróleo. Piel marrón con manchas blanquecinas. Signo inequívoco
                de la desnutrición y la anemia que afectan con mayor énfasis a
                los hijos de los pueblos originarios.
              </p>
              <p>
                Los hechos ocurrieron hace tres décadas. Daniel Saboya Mayanchi
                ahora tiene 34 años y recuerda con suma nitidez aquella infancia
                en el pueblo del distrito Villa Trompeteros.
              </p>

              <div className="img-container-doc">
                <img
                  className="img-fluid full-width"
                  src={Foto1}
                  alt="Daniel Saboya Mayanchi"
                />
                <div className="img-legend">Daniel Saboya Mayanchi</div>
              </div>

              <p>
                “Por esas acciones, los jóvenes hemos crecido con un rencor bien
                fuerte contra el Gobierno y las empresas petroleras. Ellos
                preferían botar y quemar todo, comida, colchones, maderas,
                tuberías, antes que regalarnos para utilizar en nuestras casas,
                donde no teníamos nada. Yo era uno de los niños que me iba en
                grupo a pedir las sobras de la empresa”, rememora. Daniel hoy es
                un líder indígena de las comunidades del río Corrientes.{" "}
              </p>
              <p>
                —¿Y ustedes y sus familias qué comían?<br></br>
                —Nada. Hemos crecido a punta de plátano y yuca. La miseria y el
                hambre más grande que pasamos era cuando llegaba la crecida del
                río y arrastraba los cultivos. Una vida muy difícil. Mi padre es
                pastor evangélico, creo que por eso no perdimos la fe y seguimos
                adelante.
              </p>
              <p>
                Cuando Daniel terminó el colegio se fue a Iquitos, la capital de
                Loreto. Ingresó a un seminario, pero no llegó a ser párroco. El
                padre que les enseñaba había enfermado y lo devolvieron a su
                país. “Luego yo no tenía plata para seguir otros estudios en la
                ciudad y retorné a Trompeteros”, cuenta.
              </p>
              <p>
                El pueblo de Trompetero queda a 35 minutos de viaje en avioneta
                desde Iquitos. Por río, el viaje es una eternidad.
              </p>
              <p>
                A su retorno, Daniel entró a trabajar a Pluspetrol, a través de
                una subcontratista. Su tarea consistía en retirar la maleza a
                dos metros de cada lado del oleoducto. Sueldo: 750 soles
                mensuales. “Nos hacían contrato por tres meses. Luego nos
                sacaban y contrataban a otros hermanos. Luego, igual, los
                sacaban a ellos y otra vez a nosotros. Así nos tenían para que
                no tengamos derechos laborales. Todos esos golpes recibimos”,
                lamenta.
              </p>
              <h2>La conquista de recursos</h2>
              <p>
                Un día Daniel Saboya Mayanchi amaneció con la noticia de la toma
                de un aeródromo de la empresa Pluspetrol, en la comunidad de
                Andoas, a cargo de pobladores achuar y kichwa. Era marzo del
                2008. Frente a la pantalla de un televisor, observó a los
                policías que trasladaban a algunos manifestantes hacia el penal
                de varones de Iquitos.
              </p>

              <p>
                Fue entonces que Daniel conoció por nombre a José Fachín Ruiz,
                un dirigente indígena que lideraba la manifestación, junto con
                Marco Polo Arahuanaza, Ríder Mucushua y Venancio Sandi. La
                protesta era contra Pluspetrol, que por esos años extraía
                hidrocarburo del Lote 192 (antes Lote 1AB).
              </p>
              <p>
                Daniel recuerda y asegura que había razón para protestar. La
                extracción del “oro negro” desde el subsuelo del territorio
                indígena generaba millones de dólares, pero los hijos de estos
                pueblos no solo seguían en situación de pobreza, sino también se
                enfrentaban ahora al derrame de petróleo en sus principales
                ríos, que son su fuente de vida.
              </p>
              <p>
                Sin energía eléctrica, sin agua saludable, sin colegios, sin
                hospitales, sin esperanzas de que las nuevas generaciones puedan
                alcanzar una carrera profesional, los pobladores decidieron
                hacerse escuchar, tomando el aeródromo de Andoas.
              </p>

              <p>
                Hubo denuncias contra los manifestantes, pero el Poder Judicial
                los absolvió, invocando tratados internacionales como el
                Convenio 169 de la OIT.
              </p>

              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto2}
                  alt="Manifestantes liberados tras decisión del Poder Judicial."
                />
                <div className="img-legend">
                  Manifestantes liberados tras decisión del Poder Judicial.
                  Foto: La República.
                </div>
              </div>

              <p>
                Luego de esta y otras manifestaciones, el gobierno central
                terminó emitiendo el D.U. 026-2010. El artículo 01 de esta norma
                establece que los gobiernos regionales y locales en cuyos
                territorios se explotan recursos naturales que generan canon y
                sobrecanon petrolero deben destinar “parte de esos fondos a la
                ejecución de proyectos de inversión pública y gasto social bajo
                la modalidad de Núcleos Ejecutores”. El alcance de este decreto
                era específicamente para las comunidades nativas ubicadas en las
                zonas de explotación.
              </p>
              <p>
                La norma precisaba que los gobiernos regionales tenían que
                destinar el 10% de los fondos que recibían por canon y
                sobrecanon petrolero a las comunidades, para obras de
                infraestructura en salud, educación, energía eléctrica, agua y
                saneamiento, sistemas de riego y trochas carrozables.
              </p>

              <div className="quote">
                <em>
                  “El D.U. 026-2010 tenía como finalidad transferir el 10% del
                  canon y sobrecanon petrolero a las comunidades de las zonas
                  explotación”.{" "}
                </em>
              </div>

              <p>
                La lógica principal de la intervención era transferir los
                recursos a las comunidades, a través de los núcleos ejecutores.{" "}
              </p>
              <p>
                Otro componente del decreto era la atención de las madres
                embarazadas y periodo de lactancia, además de capacitaciones en
                nutrición y otras prácticas saludables para el cuidado de los
                niños. Era un proyecto muy ambicioso. El desarrollo parecía
                asomar en las comunidades indígenas. No fue así.{" "}
              </p>
              <h2>Llegó la frustración</h2>

              <p>
                En el 2011 inició la implementación del decreto supremo, con la
                asignación de los recursos a las comunidades nativas. Los montos
                presupuestados fueron los siguientes:
              </p>
            </Fade>
            <Fade delay={80}>
              <div className="img-container-doc cuadros">
                <h3>
                  CANON PETROLERO PARA LAS COMUNIDADDES INDÍGENAS 2011-2014
                </h3>

                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">Año</th>
                      <th scope="col" className="text-right">
                        Monto S/
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2011</td>
                      <td className="text-right">10 497 303</td>
                    </tr>
                    <tr>
                      <td>2012</td>
                      <td className="text-right"> 14 636 147</td>
                    </tr>
                    <tr>
                      <td>2013</td>
                      <td className="text-right">15 124 000 </td>
                    </tr>
                    <tr>
                      <td>2014</td>
                      <td className="text-right">14 861 000</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td className="text-right">
                        <strong>55 118 669</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Fade>
            <Fade delay={80}>
              <p>
                Sin embargo, estos fondos no llegaron a manos de los comuneros.
                Por entonces, el gobernador regional de Loreto era Yván Vásquez
                Valera, quien ante unos funcionarios expresó esta frase: “Los
                indios no saben administrar dinero, nosotros haremos las obras
                por ellos”.{" "}
              </p>
              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto3}
                  alt="Yván Vásquez"
                />
                <div className="img-legend">
                  Yván Vásquez (polo verde) inaugurando una obra con fondos del
                  10% del canon petrolero destinado a las comunidades.
                </div>
              </div>
              <p>
                Fue así que los más de 55 millones de soles fueron ejecutados
                directamente por los funcionarios del Gobierno Regional de
                Loreto, generando serios cuestionamientos e indicios de
                malversación.
              </p>
              <p>
                Lejos de beneficiar a las comunidades asentadas en zona
                petrolera, la gestión destinó los fondos a proyectos como
                “mantenimiento y operatividad de las Unidades Orgánicas y
                subgerencias regionales”, “acciones normativas y administrativas
                de la alta dirección y asesoramiento”, “actividades de
                difusión”.
              </p>

              <h2>Hallazgos e investigación fiscal</h2>
              <p>
                La Contraloría General de la República realizó una auditoría y
                emitió el Informe Especial 737-2014. El daño estimado por el
                ente contralor equivale a 39 millones 809 mil 362 soles, solo
                entre 2011 y 2013. El dinero no fue invertido en las comunidades
                originarias, tal como ordenaba el D.U. 026-2010.
              </p>

              <p>
                Este organismo visitó algunas de las comunidades. Los días 21,
                22 y 23 de mayo del 2014 llegaron a siete comunidades de la zona
                petrolera: San Román, Belén de Plantayacu, Valencia, Pampa
                Hermosa, San José de Nueva Esperanza, Peruanito y San José de
                Nuevo Porvenir. Todos en el distrito de Trompeteros (Lote 8). La
                conclusión fue que no se había invertido ni un sol de aquellos
                fondos del canon petrolero.
              </p>

              <p>
                Concluido este trabajo, los hallazgos fueron enviados al
                Ministerio Público, para establecer la comisión de posibles
                delitos.
              </p>

              <p>
                “La fiscalía anticorrupción hace años tiene la investigación y
                no se ve ningún avance pese a que hay un informe grave de la
                Contraloría. Pero cuando se trata de nosotros, ahí el Ministerio
                Público es el primero en denunciarnos. Exigimos a la fiscalía
                que ya denuncie a los verdaderos responsables, porque todos esos
                millones eran para que los Núcleos Ejecutores de las comunidades
                lo manejen, no los funcionarios que los gastaron en otras cosas,
                según la investigación de Contraloría” protesta José Fachín
                Ruiz, el dirigente que participó en la toma del aeródromo de
                Andoas.
              </p>
              <p>
                En dos oportunidades, la fiscalía anticorrupción ha tratado de
                exculpar a la mayor parte de funcionarios responsables de esa
                presunta malversación, solicitando cárcel por seis años
                únicamente para dos funcionarios. Tanto la exfiscal Shella
                Sandoval Vargas, como el actual fiscal titular anticorrupción
                Michel Espinoza Aquino presentaron el mismo requerimiento mixto
                de sobreseimiento (archivo) para diez funcionarios y acusación
                solo para dos servidores, ante el Cuarto Juzgado Penal de
                Investigación Preparatoria de Loreto, a cargo de la jueza Melina
                Vargas Ascue.
              </p>
              <p>
                La jueza discrepó con el requerimiento mixto hecho por el
                Ministerio Público, por lo que a través de la notificación N°
                110976-2019 del 17 de julio 2019, pidió que se reformule la
                acusación. Un año ha transcurrido sin que hasta la fecha el
                fiscal presente su nuevo requerimiento ante el Poder Judicial.
              </p>
              <h2>Una segunda oportunidad perdida</h2>
              <p>
                Antes de enrolarse en el Ejército para servir en la frontera
                Perú – Ecuador, José Dence Fachín Ruiz, aun adolescente, caminó
                cabizbajo entre la maleza que lo conducía hasta el llamado
                “cementerio de niños” de la comunidad nativa Vista Alegre.
              </p>

              <p>
                Corría el año 1996. José Fachín se quedó parado ante la tumba de
                sus seis hermanitos y otros 35 niños más de la comunidad. Todos
                había fallecido en 1986, vomitando sangre a causa de metales
                pesados que se les había adherido a su frágil organismo, luego
                de consumir peces contaminados por Occidental Petroleum Company,
                empresa norteamericana que explotó el crudo negro en el Lote 1AB
                (hoy 192) y luego se fue del Perú sin remediar la zona
                trabajada.
              </p>
              <p>
                Dos años después, al salir de la base militar en 1998, José
                Fachín y tres compañeros indígenas sabían que el destino los
                volvería a juntar para impulsar su compromiso con los pueblos
                originarios asentados en las faldas de los lotes petroleros. El
                tema había sido materia de reflexiones durante los años del
                servicio.
              </p>

              <div className="img-container">
                <img
                  className="img-fluid full-width"
                  src={Foto4}
                  alt="José Fachín Ruiz, dirigente de Andoas"
                />
                <div className="img-legend">
                  José Fachín Ruiz, dirigente de Andoas
                </div>
              </div>

              <p>
                “En marzo del 2008 varios pueblos afectados por la petrolera
                Pluspetrol decidimos actuar frontalmente y se tomó el aeródromo
                de Andoas. Ahí nos cayó toda la represión del Gobierno.
                Detuvieron a los principales dirigentes, nos trasladaron a la
                cárcel de varones de Iquitos, hasta de terroristas nos tildaron.
                Nos enjuiciaron y finalmente nos absolvieron”, recuerda Fachín.
                Un año después, el 5 de junio del 2009, ocurrió el llamado
                ‘Baguazo’.
              </p>
              <p>
                Todo este contexto dio vida a aquel decreto de urgencia para que
                el 10% del canon petrolero sea asignado a las comunidades
                nativas asentadas en la zona de donde se extraía el
                hidrocarburo, a través de los núcleos ejecutores.
              </p>
              <p>
                Luego de la mala ejecución de estos recursos en la gestión de
                Yván Vásquez, el año 2015 asumió el cargo de gobernador regional
                Fernando Meléndez Celis. Su gestión decidió poner en marcha los
                núcleos ejecutores. Una nueva oportunidad se presentaba para el
                desarrollo de las comunidades. Pero no fue así.
              </p>
            </Fade>
            <Fade delay={80}>
              <div className="img-container-doc cuadros">
                <h3>
                  CANON PETROLERO PARA LAS COMUNIDADDES INDÍGENAS 2015-2019
                </h3>

                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">Año</th>
                      <th scope="col" className="text-right">
                        Monto S/
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>2015</td>
                      <td className="text-right">5 085 954</td>
                    </tr>
                    <tr>
                      <td>2016</td>
                      <td className="text-right"> 1 092 424</td>
                    </tr>
                    <tr>
                      <td>2017</td>
                      <td className="text-right">2 452 975 </td>
                    </tr>
                    <tr>
                      <td>2018</td>
                      <td className="text-right">5 381 471</td>
                    </tr>
                    <tr>
                      <td>2019</td>
                      <td className="text-right">6 352 832</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Total</strong>
                      </td>
                      <td className="text-right">
                        <strong>20 365 656</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <p>
                En la gestión de Fernando Meléndez Celis (2015-2018) la
                ejecución de los fondos también se dio con irregularidades: no
                hubo un adecuado acompañamiento a los núcleos ejecutores, hay
                indicios de direccionamientos y las obras están inconclusas o
                sencillamente no fueron ejecutadas.
              </p>

              <div className="quote">
                <em>
                  “Entre el 2011 y el 2019, el presupuesto por el D.U. 026-2010
                  ya suma los 75 millones 484 mil 329 soles, pero los resultados
                  no son palpables”.
                </em>
              </div>

              <p>
                En el 2019 inicia una nueva gestión y el Consejo Regional ha
                decidido investigar el presupuesto ejecutado por los núcleos
                ejecutores entre el 2015 y 2019.
              </p>
              <p>
                En general, entre el 2011 y el 2019, el presupuesto para las
                comunidades por el D.U. 026-2010 ya suma 75 millones 484 mil 329
                soles. Sin embargo, en el terreno de los hechos, los resultados
                no son palpables, según se lamenta el dirigente José Fachín.
              </p>
              <p>
                El actual gerente de asuntos indígenas del gobierno regional de
                Loreto, Omar Arévalo Vacalla, declaró al Diario La Región que
                “hay dirigentes indígenas que han sacado miles de soles por
                Núcleos Ejecutores y no han colocado ni un clavo”.
              </p>
              <p>
                Marco Polo Ramírez Arahuanaza (42) es compañero de protestas de
                José Fachín. Hoy lamenta que los procesos de lucha social no
                lograron aterrizar a la atención de las demandas de los pueblos
                indígenas.
              </p>
              <p>
                —A través de las luchas de ustedes, nació el decreto que otorga
                el 10% del canon petrolero para que se trabaje a través de
                núcleos ejecutores. ¿Cuál es tu balance?{" "}
              </p>
              <p>
                —Primero malversaron los fondos que nos correspondía (en la
                gestión 2011-2014). Luego Fernando Meléndez Celis, gobernador de
                Loreto, otorgaba el 10% para los núcleos ejecutores, pero de
                manera direccionada, algunas (obras) están inconclusas pese a
                que desembolsaron entre el 90% y hasta el 100% del presupuesto.
                Eso ha hecho mucho daño a las comunidades.
              </p>

              <h2>Núcleos bajo investigación</h2>
              <p>
                El Gobierno Regional de Loreto cuenta ahora con un nutrido
                informe sobre el estado situacional de los núcleos ejecutores
                (2015-2019). En la actual gestión, el Consejo Regional ha
                conformado una comisión investigadora de los núcleos ejecutores.
                El objetivo era visitar las comunidades para verificar la
                ejecución física, pero todo quedó bloqueado por la pandemia.
              </p>
              <div className="img-container">
                <img className="img-fluid" src={Foto5} alt="Riter Ochoa Sosa" />
                <div className="img-legend">
                  Riter Ochoa Sosa, hermano del actual gobernador regional
                  Elisban Ochoa, bajo investigación por los núcleos ejecutores.
                </div>
              </div>

              <p>
                En febrero pasado, saltó la noticia de que los núcleos
                ejecutores del año 2019 habrían estado direccionados por Riter
                Ochoa Sosa, hermano del actual gobernador de Loreto, Elisbán
                Ochoa Sosa. Y es que el presidente del núcleo ejecutor “Cocha
                Purahua”, Ananías Pasmiño Cariajano, arribó a Iquitos desde San
                Lorenzo (Datem del Marañón), para denunciarlo ante la Fiscalía.
                Según informó, la Gerencia de Asuntos Indígenas lo presentó para
                “ayudarlos”.
              </p>
              <p>
                El caso es investigado por la fiscal anticorrupción María
                Gonzales Peralta, quien intervino la vivienda del hermano,
                incautando documentos.
              </p>
              <p>
                Con esta denuncia, la comisión investigadora, que preside el
                consejero Francisco López Robles, incluirá en su trabajo a la
                actual gestión. En general, los primeros indicios apuntan a
                hechos graves como direccionamientos, la duplicidad de proyectos
                o funcionarios fantasma.
              </p>
              <p>
                Según relata el consejero López, hubo desembolsos de entre el
                90% y 100% del presupuesto de las obras o proyectos, sin
                garantías adecuadas de rendición de cuentas. “Se daba uno, dos,
                tres, cuatro desembolsos y todos estaban con observaciones,
                todos. Las comunidades del Corrientes han sido manipuladas para
                que otras personas logren sus intereses personales, eso lo
                determinará las investigaciones penales”, adelanta la autoridad.
              </p>
              <p>
                El consejero apunta que la investigación incluye al actual
                congresista por Loreto Fernando Meléndez Celis, pues era el jefe
                de pliego. “Ellos tendrán que responder sobre qué ha pasado en
                su gestión”, declaró Francisco López.
              </p>
              <p>
                Desde que fue emitido el decreto de urgencia 026-2010, muchos se
                han enriquecido con el dinero que debió beneficiar a las
                comunidades indígenas de la zona de influencia petrolera en
                Loreto. Ha pasado una década y solo hubo migajas para los hijos
                del oro negro.
              </p>
            </Fade>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotaLoreto;
